module.exports = __webpack_public_path__ + "img/i_call.c62ba1ba.svg";